import { AuthService } from '$services/auth/auth.service'
import { PostDisplay, User } from '$types'
import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css']
})
export class PostsComponent {
  @Input() postsDisplay!: PostDisplay[]
  @Input() loading!:boolean;
  @Input() scrollLoad!:boolean;
  @Input() moderatorMode!: boolean
  @Output() validatePost = new EventEmitter<PostDisplay>()
  @Output() invalidatePost = new EventEmitter<PostDisplay>()
  @Output() updatePost = new EventEmitter<PostDisplay>()
  @Output() deletePost = new EventEmitter<PostDisplay>()
  @Output() renewPost = new EventEmitter<PostDisplay>()
  user: User | undefined


  constructor(
    private readonly authService: AuthService) {
      this.user = authService.user ? authService.user : undefined
    }

}
